import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HairRemovalService } from 'src/app/_service/hair-removal.service';
import { HairRemovalModelComponent } from '../hair-removal-model/hair-removal-model.component';
import { HairRemovalPaymentModalComponent } from '../hair-removal-payment-modal/hair-removal-payment-modal.component';
declare var $: any;
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { ProductService } from 'src/app/_service/product.service';

@Component({
  selector: 'app-hair-removal',
  templateUrl: './hair-removal.component.html',
  styleUrls: ['./hair-removal.component.css']
})
export class HairRemovalComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;
  @ViewChild('pdfTable') pdfTable: ElementRef;

  perpage: number = 25; hairRemovalList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; role: string; pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; booleanValue: any = false; start_date: string = ''; end_date: string = ''; cm_access = '';
  circle = ''; circles = []; circles_copy = []; sc3Url: string = ''; bd: string; bds = []; bds_copy = []; body_part = ''; created_by: string; history_loading: boolean = true; history_loaded: boolean = false; updatedLodData = [];
  ProductID:any='';hairRemovalUserDetail:any={};txt:string='Copy';
  submitted: boolean = false; userId: string;

  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog, private router: Router, private hairremovalapi: HairRemovalService,private productapi: ProductService,) { }

  ngOnInit(): void {
    this.sharedapi.getCMAccess().subscribe((item: string) => { this.cm_access = item });
    this.sharedapi.getLeadSourceOfUser()
    this.role = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url = localStorage.getItem('s3url');
    this.cm_access = localStorage.getItem('CMAccess');
    this.getcircle(); this.getbds();
  }

  ngAfterViewInit() {
    this.loadHairRemovalData(0, this.perpage);
  }
  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  async loadHairRemovalData(pageIndex, perpage) {
    this.hairRemovalList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&body_part=' + this.body_part + '&bd=' + this.bd + '&created_by=' + this.created_by + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    await this.hairremovalapi.getAllHairRemovalData(this.paginator.pageIndex, perpage, qString)
      .subscribe((data: any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if (data.status) {
          this.hairRemovalList = data.data;
        } else {
          this.hairRemovalList = [];
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
      });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadHairRemovalData(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadHairRemovalData(event.pageIndex, event.pageSize);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  resetFilters() {
    this.clearDate();
    this.search = ''; this.circle = ''; this.bd = ''; this.body_part = ''; this.created_by = "";
    this.loadHairRemovalData(0, 25);
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  async getcircle() {
    this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getbds(status = 1) {
    this.leadapi.getbds(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  updateHairRemovalDetails(lead_id) {
    this.openHairRemovalDialog(lead_id);
  }

  openHairRemovalDialog(lead_id) {
    const dialogRef = this.dialog.open(HairRemovalModelComponent, {
      width: '100%', height: '95%',
      data: { lead_id: lead_id }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  openHistoryPopup(hairRemovalBookingId) {
    this.history_loading = true; this.history_loaded = false;
    this.hairremovalapi.getFullHairRemovalHistory(hairRemovalBookingId).subscribe((data: any) => {
      this.history_loading = false;
      this.history_loaded = true;
      if (data.status) {
        this.updatedLodData = data.data;
      } else {
        this.updatedLodData = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
    $('#myHistoryModal').modal();
  }

  closeHistoryPopup() {
    $('#myHistoryModal').modal('hide');
  }

  sharePaymentLink(lead_id,type){
    const dialogRef = this.dialog.open(HairRemovalPaymentModalComponent, {
        width: '45%',
        height: '50%',
        data:{lead_id:lead_id,type:type}
    });
    dialogRef.afterClosed().subscribe(result => {
        console.log(result);
    });
}

hideModal(val)
{
    if(val=='1'){
        $('#myModal').modal('hide');
    }
}

public downloadAsPDF() {
  const pdfTable = this.pdfTable.nativeElement;
  var html = htmlToPdfmake(pdfTable.innerHTML);
  const documentDefinition = { content: html };
  pdfMake.createPdf(documentDefinition).download('LHR_'+this.ProductID+'.pdf');
}

async viewHairRemovalDetails(product_id)
{
    this.ProductID= product_id;
    this.txt='Copy';
    $('#myModal').modal();
    await this.hairremovalapi.viewHairRemovalDetails(product_id).subscribe((data:any) => {
        if(data.status)
        {
            this.hairRemovalUserDetail = data.data;
        }else{
            this.hairRemovalUserDetail = {};
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

}
